import { PremiumFilledSvg } from "@crunchyroll/cx-web-components";
import externalLinks from "../../../constants/externalLinks";
import { getBasename } from "../../../helpers/routingHelpers";
import { getUpsellRedirectUrl } from "../../../helpers/upsellHelpers";
import FooterItem from "../FooterItem";
import FooterSection from "../FooterSection";
import FooterDoNotSellItemSvg from "./FooterDoNotSellItemSvg";

import styles from "./FooterMoreStuffSection.module.scss";
import { useUserContext } from "../../../features/user/userContext";
import { useCountry } from "../../../features/localization/hooks/country";
import displayCookieConsentModal from "../../../features/evidon/helpers/displayCookieConsentModal";

const FooterMoreStuffSection = ({ className = "" }) => {
  const user = useUserContext();
  const country = useCountry();

  return (
    <FooterSection titleId="footer.crunchyroll" className={className}>
      {!user?.isPremium && (
        <FooterItem
          textClassName={styles.premiumItem}
          iconClassName={styles.premiumIcon}
          icon={PremiumFilledSvg}
          messageId={
            !user || user.isEligible
              ? "footer.start_free_trial"
              : "footer.go_premium"
          }
          href={getUpsellRedirectUrl("newweb_organic_footer_news")}
        />
      )}
      <FooterItem messageId="footer.about" href={externalLinks.about} />
      <FooterItem
        messageId="footer.help_faq"
        href={externalLinks.helpCenter}
        isNewTab
      />
      <FooterItem messageId="footer.terms" href={externalLinks.tos} isNewTab />
      <FooterItem
        messageId="footer.privacy_policy"
        href={externalLinks.privacy}
        isNewTab
      />
      {!getBasename() && (
        <FooterItem
          messageId="footer.ad_choices"
          href={externalLinks.adChoices}
          isNewTab
        />
      )}
      {!getBasename() && (
        <FooterItem
          messageId="footer.privacy_choices"
          icon={FooterDoNotSellItemSvg}
          iconPosition="end"
          iconClassName={styles.doNotSellIcon}
          href={externalLinks.doNotSellMyPersonalInformation}
          isNewTab
        />
      )}

      <FooterItem
        messageId="footer.cookie_consent_tool"
        onClick={displayCookieConsentModal}
      />
      <FooterItem
        messageId="footer.press_inquiries"
        href="mailto:pr@crunchyroll.com"
        isNewTab
      />
      <FooterItem
        messageId="footer.get_apps"
        href={externalLinks.devices}
        isNewTab
      />
      <FooterItem
        messageId="footer.redeem_gift_card"
        href={externalLinks.redeem}
        isNewTab
      />
      <FooterItem messageId="footer.jobs" href={externalLinks.jobs} isNewTab />
      {country === "FR" && (
        <FooterItem
          messageId="footer.mf_ration"
          href={externalLinks.genderEqualityIndex}
        />
      )}
      {country === "GB" && (
        <FooterItem
          messageId="footer.modern_slavery_transparency_statement"
          href={externalLinks.modernSlaveryTransparencyStatement}
          isNewTab
        />
      )}
    </FooterSection>
  );
};

export default FooterMoreStuffSection;
